import React from "react";
import { Card, Typography } from "@douyinfe/semi-ui";
import { AiCoachDiagnosis } from "../../../api/aiCoach";
import { radius, sp } from "../styles";

const { Title, Paragraph, Text } = Typography;

interface Props {
  diagnosis: AiCoachDiagnosis;
  totalCustomers: number;
  analyzedCustomers: number;
}

const DiagnosisPanel: React.FC<Props> = ({ diagnosis, totalCustomers, analyzedCustomers }) => {
  const sampleBase = analyzedCustomers > 0 ? analyzedCustomers : totalCustomers;
  const coverage = totalCustomers > 0 ? Math.round((analyzedCustomers / totalCustomers) * 100) : 0;

  return (
    <Card
      style={{ marginBottom: sp.lg, borderRadius: radius.md }}
      bodyStyle={{ padding: sp.lg }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          marginBottom: sp.md,
        }}
      >
        <Title heading={5} style={{ margin: 0 }}>
          AI 诊断 · 核心问题
        </Title>
        <Text type="tertiary" size="small">
          样本覆盖 {analyzedCustomers}/{totalCustomers}（{coverage}%）
        </Text>
      </div>

      <Paragraph
        style={{
          fontSize: 15,
          lineHeight: 1.75,
          color: "var(--semi-color-text)",
          margin: 0,
        }}
      >
        {diagnosis.coreProblem}
      </Paragraph>

      {diagnosis.scriptAmmo && (
        <div
          style={{
            marginTop: sp.lg,
            padding: sp.md,
            background: "var(--semi-color-info-light-default)",
            borderLeft: `3px solid var(--semi-color-info)`,
            borderRadius: radius.sm,
          }}
        >
          <Text strong style={{ color: "var(--semi-color-info)" }}>
            🎯 本周话术弹药
          </Text>
          <div style={{ marginTop: sp.xs, color: "var(--semi-color-text)" }}>
            {diagnosis.scriptAmmo}
          </div>
        </div>
      )}
    </Card>
  );
};

export default DiagnosisPanel;
